import { render, staticRenderFns } from "./ReportPurchases.vue?vue&type=template&id=43d6f579&scoped=true"
import script from "./ReportPurchases.vue?vue&type=script&lang=js"
export * from "./ReportPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d6f579",
  null
  
)

export default component.exports